import styled from 'styled-components';

export const Wrapper = styled.div<{
  color: string;
}>`
  padding: 4px 12px 4px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background-color: ${(v) => v.color};
  width: max-content;

  > span {
    font-size: 12px;
    text-align: center;
    line-height: 16px;
    color: #ffffff;
  }
`;
